import {
  GET_AGGREGATE_PROPERTIES,
  GET_SELECTED_PROJECT,
  GET_SELECTED_MODEL,
  GET_REVIEW_MODE,

  GET_STATE_OBJ_PROPERTIES,
  SELECTED_MODEL_ARRAY,
  UPDATE_META_PROP_DATA,
  UPDATE_SELECTED_TAG,
  UPDATE_SELECTED_GUID,

  UPDATE_DYNA_PROP_VALUES,
  UPDATE_STAT_PROP_VALUES,
  UPDATE_TAGS_CATS_LIST,
  UPDATE_SELECTED_PROP_VALUES,
  UPDATE_SELECTED_SCHEDULE,
  SHOW_TAGS_CATS_LIST,
  SHOW_META_PROP_TAG_LIST,
  UPDATE_SHOW_ALL,
  UPDATE_SHOW_SELECTION,
  UPDATE_ADDITIONAL_TABS,
  SET_TRAINING_DATA,
  UPDATE_MARKUP_STATE,
  UPDATE_PDF_STATE,
  UPDATE_PDF,
  UPDATE_WORKFLOW_STATE,
  SET_MARKUP_EXTENSION,
  GET_MARKUPS,
  SET_VIEWERAPP_STATE,
} from "../constants/Constants";

export function properties(payload) {
  return {
    type: GET_AGGREGATE_PROPERTIES,
    payload,
  };
}

export const showObjProperties = (bool) => ({
  type: GET_STATE_OBJ_PROPERTIES,
  payload: bool,
});

export const setViewerAppState = (viewerState) => ({
  type: SET_VIEWERAPP_STATE,
  payload: viewerState,
});

export const getSelectedProject = (id) => ({
  type: GET_SELECTED_PROJECT,
  payload: id,
});

export const getSelectedModel = (Item) => ({
  type: GET_SELECTED_MODEL,
  payload: Item,
});

export const getSelectedModelArray = (array) => ({
  type: SELECTED_MODEL_ARRAY,
  payload: array,
});

export const getReviewId = (bool) => ({
  type: GET_REVIEW_MODE,
  payload: bool,
});

export const reSet = () => ({
  type: "RESET_APP",
  payload: [],
});

export function updateMetaProp(data) {
  return {
    type: UPDATE_META_PROP_DATA,
    payload: data,
  };
}

export function updateSelectedTag(data) {
  return {
    type: UPDATE_SELECTED_TAG,
    payload: data,
  };
}

export function updateSelectedGuId(data) {
  return {
    type: UPDATE_SELECTED_GUID,
    payload: data,
  };
}

export function updateDynaPropValues(data) {
  return {
    type: UPDATE_DYNA_PROP_VALUES,
    payload: data,
  };
}

export function updateStatPropValues(data) {
  return {
    type: UPDATE_STAT_PROP_VALUES,
    payload: data,
  };
}

export function updateTagsCatsList(data) {
  return {
    type: UPDATE_TAGS_CATS_LIST,
    payload: data,
  };
}
export function showTagsCatsList(data) {
  return {
    type: SHOW_TAGS_CATS_LIST,
    payload: data,
  };
}
export function showMetaPropTagList(data) {
  return {
    type: SHOW_META_PROP_TAG_LIST,
    payload: data,
  };
}

export function updateSelectedPropValues(data) {
  return {
    type: UPDATE_SELECTED_PROP_VALUES,
    payload: data,
  };
}

export function updateSelectedSchedule(data) {
  return {
    type: UPDATE_SELECTED_SCHEDULE,
    payload: data,
  };
}

export function updateShowAll(data) {
  return {
    type: UPDATE_SHOW_ALL,
    payload: data,
  };
}

export function updateShowSelection(data) {
  return {
    type: UPDATE_SHOW_SELECTION,
    payload: data,
  };
}
export function updateAdditionalTabs(data) {
  return {
    type: UPDATE_ADDITIONAL_TABS,
    payload: data,
  };
}
export function updateMarkupState(data) {
  return {
    type: UPDATE_MARKUP_STATE,
    payload: data,
  };
}

export function updateWorkflowState(data) {
  return {
    type: UPDATE_WORKFLOW_STATE,
    payload: data,
  };
}

export function updatePdfState(data) {
  return {
    type: UPDATE_PDF_STATE,
    payload: data,
  };
}
export function updatePdf(data) {
  return {
    type: UPDATE_PDF,
    payload: data,
  };
}

export const getMarkups = (markups) => ({
  type: GET_MARKUPS,
  payload: markups,
});
export function setMarkupExtension(markup) {
  return {
    type: SET_MARKUP_EXTENSION,
    payload: markup,
  };
}
export const updateTrainingContent = (data) => ({
  type: SET_TRAINING_DATA,
  payload: data,
});

export const updateMarkupTitle = (title) => ({
  type: "SET_TITLE",
  payload: title,
});

export const updateMarkupReviewerId = (reviewerId) => ({
  type: "SET_REVIEWERID",
  payload: reviewerId,
});
//---------------------------------------------------
export const update = (type,data) => ({
  type: type,
  payload: data,
});

